import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { CodeCoValidatorService } from '../validators/code-co-validator.service';
import { DepartOrgValidatorService } from '../validators/depart-org-validator.service';
import { TypeDocValidatorService } from '../validators/type-doc-validator.service';
import { CheckEmailValidatorsService } from '../validators/check-email-validators.service';
import { CheckNumberIDValidatorsService } from '../validators/check-id-validators.service';

@Injectable({providedIn: 'root'})
export class ValidatorsService {

  public emailPattern:  string = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  public idPattern:     string = "^[0-9]*$";

  // Expresion regular para validar minimo 6 caracteres, al menos una letra mayuscula, al menos una letra minuscula, al menos un numero, al menos un caracter y sin espacios en blanco.

  // public passwordPattern: string = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{6,}$";
  public passwordPattern: string = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@#$%^&+=])[a-zA-Z\\d@#$%^&+=]{6,}$";


  constructor (
    private checkCodeValidator              : CodeCoValidatorService,
    private departOrgValidatorService       : DepartOrgValidatorService,
    private typeDocValidatorService         : TypeDocValidatorService,
    private checkEmailValidatorService      : CheckEmailValidatorsService,
    private checkNumberIDValidatorService   : CheckNumberIDValidatorsService,
    ) {}

  public isValidField( form: FormGroup, field: string ) {
    return form.controls[field].errors && form.controls[field].touched;
  }

  public codeLengthValidator = (control: FormControl): ValidationErrors | null => {

    const code = control.value;

    if (code && code.length !== 3) {
      return { codeLength: true };
    }
    return null;
  }

  //como agregar la validacion noWhitespaceValidator al getFieldError
  public required(control: AbstractControl): ValidationErrors | null {
    return (control.value || '').trim().length === 0 ? { 'required': true } : null;
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  public getFieldError( form: FormGroup, field: string ): string | null {
    if ( !form.controls[field] ) return null;

    const errors = form.controls[field].errors || {};

    for (const key of Object.keys(errors)) {
      switch ( key ) {
        case 'required':
          return 'Este campo es requerido.';

        case 'minlength':
          return `Debe digitar ${ errors['minlength'].requiredLength } caracteres.`;

        case 'codeTaken':
          return this.checkCodeValidator.codeTakenError;

        case 'deptTaken':
          return this.departOrgValidatorService.deptTakenError;

        case 'typeDocTaken':
          return this.typeDocValidatorService.typeDocTakenError;

        case 'emailTaken':
          return this.checkEmailValidatorService.emailTakenError;

        case 'numberIDTaken':
          return this.checkNumberIDValidatorService.numberIDTakeError;

        case 'alreadyExist':
          return 'El valor ya existe.';

        case 'numberIDError':
          return 'Verifique el número y/o Tipo ID.';

        case 'docAlreadyExist':
          return 'El tipo de documento ya existe.';

        case 'pattern':
          if ( field === 'email' ) {
            return 'El formato del correo es incorrecto.';
          } else if ( field === 'noIdentification' ) {
            return 'Debe digitar solo números.';
          } else if ( field === 'password' ) {
            return 'Debe contener al menos un caracter minusculas<, mayuscula y numeros.';
          } else {
            return `Error en el campo ${field}.`;
          }

        case 'customError':
          return errors['customError'];

        default:
          return `Error en el campo ${field}.`;

      }
    }

    return null;
  }
}
